// extracted by mini-css-extract-plugin
export default {"modify_order_header":"zt","center":"At","empty":"Bt","pending":"Ct","referralTitle":"Et","wrapper":"Ft","title":"Gt","tabs":"Ht","tab":"It","active":"Jt","btn":"Kt","rewards_table":"Lt"};
    if(module.hot) {
      // 1713996741351
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  